var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.725.283a.747.747 0 00-1.058 0L5 3.943 1.332.275A.747.747 0 10.275 1.333L3.942 5 .275 8.668a.747.747 0 101.057 1.057L5 6.058l3.667 3.667a.747.747 0 101.058-1.057L6.057 5l3.668-3.667a.752.752 0 000-1.05z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/exit.513dee77c54b6011471125c7174134dd.svg";